const ACTION_COL_ID = 'actionCol';

/** colIds or field names of columns to show in Select Drivers step (Driver #, Route, Driver, Driver Status, Equip Type, Proj MTY, EST GateIn) */
const VISIBLE_COLUMN_IDS = new Set([
  'driverNumber',
  'routeName',
  'driverName',
  'currentDriverStatus',
  'trailerName',
  'estimatedEmptyTime',
  'arriveAtTerminalTime',
]);

const isColumnVisible = (col: Record<string, unknown>): boolean => {
  const colId = col.colId as string | undefined;
  const field = col.field as string | undefined;
  if (colId === ACTION_COL_ID) return false;
  if (col.children != null) return false;
  return Boolean(
    (colId && VISIBLE_COLUMN_IDS.has(colId)) || (field && VISIBLE_COLUMN_IDS.has(field))
  );
};

/** Dedicated selection column so checkbox always shows (no dependency on first-column resolution or saved prefs). */
const SELECTION_COLUMN: Record<string, unknown> = {
  headerName: '',
  colId: 'selectDriversCheckbox',
  headerCheckboxSelection: true,
  checkboxSelection: true,
  minWidth: 48,
  maxWidth: 48,
  pinned: 'left',
  lockPosition: true,
  lockPinned: true,
  suppressMovable: true,
  filter: false,
  sortable: false,
  headerClass: 'headerCellStyle',
  cellClass: 'gridCell-centerAlign',
};

export interface GridConfigShape {
  columns: Array<Record<string, unknown>>;
  [key: string]: unknown;
}

export const applySelectDriversGridOverrides = <T extends GridConfigShape>(config: T): T => {
  const columns = config.columns || [];
  const visibleColumns = columns.filter((col) => isColumnVisible(col as Record<string, unknown>));
  const withCheckboxColumn = [SELECTION_COLUMN, ...visibleColumns];
  return { ...config, columns: withCheckboxColumn };
};
